import { Controller } from "@hotwired/stimulus"

export default class QuestionAnswerController extends Controller {
  static targets = ["radio", "questionContainer", "answer", "answerContainer"];
  static outlets = ["popover-sheet"];

  static values = {
    hideQuestionsOnSelection: Boolean,
  };

  declare readonly radioTargets: HTMLInputElement[]
  declare readonly questionContainerTarget: HTMLElement
  declare readonly answerTargets: HTMLElement[]
  declare readonly answerContainerTargets: HTMLElement[]
  declare readonly hideQuestionsOnSelectionValue: boolean
  declare readonly popoverSheetOutlet: { show: () => void, hide: () => void }
  declare readonly hasPopoverSheetOutlet: boolean

  select(event: Event): void {
    const radio = event.currentTarget as HTMLInputElement
    const questionKey = radio.value;

    this.radioTargets.forEach(r => { r.checked = r.value === questionKey })

    this.answerTargets.forEach(el => {
      el.classList.toggle("is-completely-hidden", el.dataset.questionAnswerKey !== questionKey)
    });

    this.answerContainerTargets.forEach(el => el.classList.remove("is-completely-hidden"));

    if (this.hasPopoverSheetOutlet) {
      this.popoverSheetOutlet.show()
    }

    if (this.hideQuestionsOnSelectionValue) {
      this.questionContainerTarget.classList.add("is-completely-hidden");
    }
  }

  reset(): void {
    this.answerContainerTargets.forEach(el => el.classList.add("is-completely-hidden"));
    this.questionContainerTarget.classList.remove("is-completely-hidden");
    this.radioTargets.forEach(r => { r.checked = false })

    if (this.hasPopoverSheetOutlet) {
      this.popoverSheetOutlet.hide()
    }
  }
}
